import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'empathy-carousel-form',
  templateUrl: './carousel-form.component.html',
  styleUrl: './carousel-form.component.scss'
})
export class CarouselFormComponent implements OnInit {
  @ViewChildren('questionCards') questionCards!: QueryList<ElementRef>;
  @ViewChildren('questionOptions') questionOptions!: QueryList<ElementRef>;

  @Input() question!: AbstractControl;
  @Input() disabled: boolean;

  cards: FormArray;
  options: FormArray;

  private readonly MINIMUM_OPTIONS = 2;
  private readonly MINIMUM_CARDS = 1;

  ngOnInit(): void {
    this.cards = this.question.get('cards') as FormArray;
    this.options = this.question.get('options') as FormArray;
  }

  jumpOption(index: number): void {
    if (index < 0) {
      this.questionCards.get(this.questionCards.length - 1)?.nativeElement.focus();
    } else {
      this.questionOptions.get(index + 1)?.nativeElement.focus();
    }
  }

  addOption(): void {
    const options = this.question.get('options') as FormArray;
    options.push(new FormControl('', [Validators.required]));

    requestAnimationFrame(() => {
      this.questionOptions.last.nativeElement.focus();
    });
  }

  deleteOption(index: number): void {
    const optionsLength = (this.question.get('options') as FormArray).controls.length;

    if (optionsLength > this.MINIMUM_OPTIONS) {
      const options = this.question.get('options') as FormArray;
      if (options.at(index).value === '') {
        options.removeAt(index);
        requestAnimationFrame(() => {
          if (index > 0) {
            (this.questionOptions.get(index) ?? this.questionOptions.get(index - 1))?.nativeElement.focus();
          }
        });
      }
    }
  }

  jumpCard(index: number): void {
    if (this.questionCards.length <= index) {
      this.questionOptions.get(0)?.nativeElement.focus();
    } else {
      this.questionCards.get(index)?.nativeElement.focus();
    }
  }

  addCard(): void {
    const cards = this.question.get('cards') as FormArray;
    cards.push(new FormControl('', []));

    requestAnimationFrame(() => {
      this.questionCards.last.nativeElement.focus();
    });
  }

  deleteCard(index: number): void {
    const cardsLength = (this.question.get('cards') as FormArray).controls.length;

    if (cardsLength > this.MINIMUM_CARDS) {
      const cards = this.question.get('cards') as FormArray;
      if (cards.at(index).value === '') {
        cards.removeAt(index);
        requestAnimationFrame(() => {
          if (index > 0) {
            (this.questionCards.get(index) ?? this.questionCards.get(index - 1))?.nativeElement.focus();
          }
        });
      }
    }
  }
}
